import BaseElectronImplementation from './Base.impl';
import CodeTemplateAPI from '../../interfaces/CodeTemplateAPI';

export default class CodeTemplatesImpl extends BaseElectronImplementation implements CodeTemplateAPI {
    getCodeSets = async (matterId: number, search: string, offset: number = 0, limit: number = 200) => {
        return [];
    }
}